// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seller-messages {
  display: grid;
  grid-template-columns: minmax(14rem, 22rem) minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
}

.seller-messages__inbox,
.seller-messages__conversation {
  background: #fff;
  border: 1px solid #d7dce5;
  border-radius: 8px;
  padding: 1rem;
}

.seller-messages__thread-list,
.seller-messages__message-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.seller-messages__thread-list li + li {
  margin-top: 0.5rem;
}

.seller-messages__thread {
  width: 100%;
  border: 1px solid #d7dce5;
  border-radius: 6px;
  background: #fff;
  color: inherit;
  cursor: pointer;
  display: grid;
  gap: 0.25rem;
  padding: 0.75rem;
  text-align: left;
}

.seller-messages__thread--selected,
.seller-messages__thread:hover {
  border-color: #4a73c9;
  background: #eef4ff;
}

.seller-messages__composer {
  display: grid;
  gap: 0.5rem;
  margin: 1rem 0;
}

.seller-messages__composer textarea {
  min-height: 7rem;
  resize: vertical;
}

.seller-messages__composer button {
  justify-self: start;
}

.seller-messages__contact-warning {
  background: #fff5d6;
  border-left: 4px solid #bd8100;
  padding: 0.75rem;
}

.seller-messages-page__warning,
.seller-messages-page__help {
  margin-bottom: 1rem;
}

@media (max-width: 800px) {
  .seller-messages {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Messages/SellerMessages.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".seller-messages {\n  display: grid;\n  grid-template-columns: minmax(14rem, 22rem) minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n}\n\n.seller-messages__inbox,\n.seller-messages__conversation {\n  background: #fff;\n  border: 1px solid #d7dce5;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.seller-messages__thread-list,\n.seller-messages__message-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.seller-messages__thread-list li + li {\n  margin-top: 0.5rem;\n}\n\n.seller-messages__thread {\n  width: 100%;\n  border: 1px solid #d7dce5;\n  border-radius: 6px;\n  background: #fff;\n  color: inherit;\n  cursor: pointer;\n  display: grid;\n  gap: 0.25rem;\n  padding: 0.75rem;\n  text-align: left;\n}\n\n.seller-messages__thread--selected,\n.seller-messages__thread:hover {\n  border-color: #4a73c9;\n  background: #eef4ff;\n}\n\n.seller-messages__composer {\n  display: grid;\n  gap: 0.5rem;\n  margin: 1rem 0;\n}\n\n.seller-messages__composer textarea {\n  min-height: 7rem;\n  resize: vertical;\n}\n\n.seller-messages__composer button {\n  justify-self: start;\n}\n\n.seller-messages__contact-warning {\n  background: #fff5d6;\n  border-left: 4px solid #bd8100;\n  padding: 0.75rem;\n}\n\n.seller-messages-page__warning,\n.seller-messages-page__help {\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 800px) {\n  .seller-messages {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
